const de = {
  // Login Page
  login: {
    title: 'MedRahi',
    subtitle: 'Patienten mit vertrauenswürdiger indischer Versorgung verbinden',
    emailLabel: 'E-Mail',
    emailPlaceholder: 'sie@beispiel.de',
    passwordLabel: 'Passwort',
    passwordPlaceholder: '••••••••',
    signInButton: 'Anmelden',
    signingIn: 'Anmeldung läuft...',
    noAccount: 'Noch kein Konto?',
    signUp: 'Registrieren',
  },
  
  // Register Page
  register: {
    title: 'MedRahi Beitreten',
    subtitle: 'Erstellen Sie Ihr Konto, um loszulegen',
    fullNameLabel: 'Vollständiger Name',
    emailLabel: 'E-Mail',
    passwordLabel: 'Passwort',
    roleLabel: 'Ich bin ein',
    rolePatient: 'Patient',
    roleDoctor: 'Arzt',
    roleHospital: 'Krankenhaus',
    countryLabel: 'Land',
    countryPlaceholder: 'Ihr Heimatland',
    phoneLabel: 'Telefon (Optional)',
    createAccountButton: 'Konto Erstellen',
    creatingAccount: 'Konto wird erstellt...',
    haveAccount: 'Haben Sie bereits ein Konto?',
    signIn: 'Anmelden',
  },
  
  // Navigation
  nav: {
    treatments: 'Behandlungen',
    doctors: 'Ärzte',
    hospitals: 'Krankenhäuser',
    services: 'Dienstleistungen',
    wellness: 'Wellness',
    medicalVisa: 'Medizinvisum',
    signIn: 'Anmelden',
    getStarted: 'Loslegen',
    backToHome: 'Zurück zur Startseite',
  },
  
  // Services Menu
  servicesMenu: {
    airportPickup: 'Flughafentransfer',
    languageInterpreter: 'Sprachdolmetscher',
    surroundingTours: 'Kostenlose Touren',
    nursingCare: 'Pflegeunterstützung',
    physiotherapist: 'Physiotherapeut',
    travelAccommodation: 'Reise & Unterkunft',
    videoConsultations: 'Videokonsultationen',
  },
  
  // Landing Page
  landing: {
    heroTag: 'Vertraut von über 10.000 internationalen Patienten',
    heroTitle1: 'Erleben Sie',
    heroTitle2: 'Weltklasse',
    heroTitle3: 'Gesundheitsversorgung in Indien',
    heroSubtitle: 'Verbinden Sie sich mit Indiens besten Ärzten und Krankenhäusern. Erhalten Sie erschwingliche, hochwertige medizinische Behandlung mit transparenten Preisen und personalisierter Betreuung.',
    ctaStart: 'Starten Sie Ihre Reise',
    ctaExplore: 'Portal erkunden',
    isoCertified: 'ISO-zertifiziert',
    nabhAccredited: 'NABH-akkreditiert',
    jciStandards: 'JCI-Standards',
    platformHighlights: 'Plattform-Highlights',
    realTimeStats: 'Echtzeit-Statistiken',
    activeNow: 'Jetzt aktiv',
    verifiedDoctors: 'Verifizierte Ärzte',
    partnerHospitals: 'Partnerkrankenhäuser',
    successRate: 'Erfolgsquote',
    patientRating: 'Patientenbewertung',
    patientsTreated: 'Patienten diesen Monat behandelt',
    
    // Features Section
    whyChoose: 'Warum MedRahi wählen',
    featuresTitle: 'Medizinische Exzellenz trifft indische Gastfreundschaft',
    featuresSubtitle: 'Erleben Sie die perfekte Mischung aus modernster Medizintechnologie und traditioneller indischer Wärme',
    
    features: {
      transparentPricing: {
        title: 'Transparente Preise',
        desc: 'Vergleichen Sie Angebote von mehreren Krankenhäusern. Keine versteckten Kosten. Sparen Sie bis zu 70% im Vergleich zu westlichen Ländern.',
      },
      worldClassFacilities: {
        title: 'Weltklasse-Einrichtungen',
        desc: 'Zugang zu JCI-akkreditierten Krankenhäusern mit modernster Technologie und internationalen Standards.',
      },
      verifiedSpecialists: {
        title: 'Verifizierte Spezialisten',
        desc: 'Verbinden Sie sich mit international ausgebildeten, zertifizierten Ärzten mit jahrzehntelanger Erfahrung.',
      },
      securePrivate: {
        title: 'Sicher & Privat',
        desc: 'Bankniveau-Verschlüsselung für Ihre medizinischen Unterlagen. HIPAA-konformer Datenschutz.',
      },
      endToEndSupport: {
        title: 'Rundum-Unterstützung',
        desc: 'Von der Visa-Hilfe bis zur Nachbehandlung. Wir kümmern uns um alles für Ihren Komfort.',
      },
      quickResponse: {
        title: 'Schnelle Antwort',
        desc: 'Erhalten Sie Angebote innerhalb von 24 Stunden. Echtzeit-Nachrichten mit Ärzten. Sofortige Termine.',
      },
    },
    
    // How It Works
    yourJourney: 'Ihre Reise',
    howItWorksTitle: 'Einfache Schritte zu erstklassiger Versorgung',
    howItWorksSubtitle: 'Von der Anfrage bis zur Genesung sind wir bei jedem Schritt an Ihrer Seite',
    steps: {
      step1: { title: 'Anfrage einreichen', desc: 'Erzählen Sie uns von Ihrem Zustand und Ihren medizinischen Bedürfnissen' },
      step2: { title: 'Angebote vergleichen', desc: 'Erhalten Sie detaillierte Angebote von verifizierten Ärzten' },
      step3: { title: 'Behandlung planen', desc: 'Wählen Sie Ihren Arzt und planen Sie Termine' },
      step4: { title: 'Behandlung erhalten', desc: 'Erhalten Sie Versorgung und genießen Sie Ihre Genesung in Indien' },
    },
    startJourney: 'Starten Sie Ihre Behandlungsreise',
    
    // Specializations
    popularSpecializations: 'Beliebte Behandlungsspezialisierungen',
    indiaExpertise: 'Indiens Expertise erstreckt sich über alle medizinischen Bereiche',
    specializations: {
      cardiology: 'Kardiologie',
      orthopedics: 'Orthopädie',
      oncology: 'Onkologie',
      fertility: 'Fruchtbarkeit',
      dental: 'Zahnmedizin',
      cosmetic: 'Kosmetik',
    },
    
    // For Doctors & Hospitals
    forDoctors: 'Für Ärzte',
    forDoctorsDesc: 'Treten Sie Indiens führender Medizintourismus-Plattform bei und verbinden Sie sich mit internationalen Patienten, die Ihre Expertise suchen.',
    forHospitals: 'Für Krankenhäuser',
    forHospitalsDesc: 'Partner werden Sie mit MedRahi, um internationale Patienten anzuziehen und Ihre Weltklasse-Einrichtungen zu präsentieren.',
    registerAsDoctor: 'Als Arzt registrieren',
    registerAsHospital: 'Als Krankenhaus registrieren',
    
    doctorBenefits: [
      'Erweitern Sie Ihre Praxis global',
      'Verifizierte Patientenanfragen',
      'Transparentes Preissystem',
      'Engagiertes Support-Team',
      'Steigern Sie Ihren Ruf',
    ],
    hospitalBenefits: [
      'Internationalen Zustrom erhöhen',
      'Infrastruktur präsentieren',
      'Ärzte effizient verwalten',
      'Echtzeit-Analysen',
      'Marketing-Unterstützung',
    ],
    
    // CTA Section
    ctaTitle: 'Bereit, indische Gesundheitsversorgung zu erleben?',
    ctaSubtitle: 'Schließen Sie sich Tausenden zufriedener Patienten an, die Indien für ihre medizinische Behandlung gewählt haben',
    getStartedNow: 'Jetzt loslegen',
    
    // Footer
    healthcareWithoutBorders: 'Gesundheit ohne Grenzen',
    footerDesc: 'Verbindung internationaler Patienten mit Indiens besten Gesundheitsfachleuten seit 2024.',
    quickLinks: 'Schnelllinks',
    contactUs: 'Kontakt',
    copyright: '© 2024 MedRahi. Alle Rechte vorbehalten. Mit ❤️ in Indien gemacht',
    privacyPolicy: 'Datenschutzrichtlinie',
    termsOfService: 'Nutzungsbedingungen',
    cookiePolicy: 'Cookie-Richtlinie',
  },
  
  // Service Pages Common
  services: {
    enquireNow: 'Jetzt anfragen - Kostenloses Angebot',
    responseTime: 'Antwort innerhalb von 24 Stunden',
    whatsIncluded: 'Was enthalten ist',
    
    enquiryForm: {
      fullName: 'Vollständiger Name',
      email: 'E-Mail',
      phone: 'Telefon',
      country: 'Land',
      countryPlaceholder: 'Ihr Heimatland',
      additionalRequirements: 'Zusätzliche Anforderungen',
      additionalPlaceholder: 'Erzählen Sie uns mehr über Ihre Bedürfnisse...',
      cancel: 'Abbrechen',
      submit: 'Anfrage senden',
      successMessage: 'Anfrage erfolgreich gesendet! Unser Team wird Sie innerhalb von 24 Stunden kontaktieren.',
    },
    
    airportPickup: {
      title: 'Flughafentransfer-Service',
      subtitle: 'Stressfreie Flughafentransfers für Ihre medizinische Reise. Sicherer, zuverlässiger und komfortabler Transport.',
      mainTitle: 'Willkommen zu stressfreiem Reisen',
      mainDesc1: 'In einem neuen Land für eine medizinische Behandlung anzukommen kann überwältigend sein. Unser engagierter Flughafentransfer-Service sorgt dafür, dass Sie Ihre medizinische Reise mit Komfort und Seelenfrieden beginnen und beenden.',
      mainDesc2: 'Unsere professionellen Fahrer empfangen Sie am Flughafen mit einem personalisierten Willkommensschild, helfen mit Ihrem Gepäck und transportieren Sie sicher zu Ihrer Unterkunft oder Ihrem Krankenhaus.',
      features: {
        availability: { title: '24/7 Verfügbarkeit', desc: 'Rund-um-die-Uhr-Service für frühe Morgen- oder späte Nachtflüge.' },
        safe: { title: 'Sicher & Zuverlässig', desc: 'Erfahrene, lizenzierte Fahrer mit sauberen Fahrzeugen.' },
        doorToDoor: { title: 'Tür-zu-Tür-Service', desc: 'Direkttransport vom Flughafen zum Hotel, Krankenhaus oder anderen Orten.' },
        flightMonitoring: { title: 'Flugüberwachung', desc: 'Wir verfolgen Ihren Flugstatus, um Abholzeiten bei Verspätungen anzupassen.' },
      },
      included: [
        'Empfang am Ankunftsbereich mit Namensschild',
        'Gepäckhilfe und Flughafennavigation',
        'Komfortable, klimatisierte Fahrzeuge',
        'Englischsprachige Fahrer, vertraut mit Krankenhausrouten',
        'Rollstuhlzugängliche Fahrzeuge auf Anfrage',
        'Kostenloses Flaschenwasser',
        'Mobile Ladepunkte im Fahrzeug',
        'Kostenlose Wartezeit bei Flugverspätungen',
      ],
      vehicleOptions: 'Fahrzeugoptionen',
      sedan: { title: 'Limousine', desc: 'Für 1-2 Passagiere', features: ['Bequeme Sitze', '2 große Koffer', 'Klima & Musikanlage'] },
      suv: { title: 'SUV', desc: 'Für 3-4 Passagiere', features: ['Geräumiger Innenraum', '4 große Koffer', 'Extra Beinfreiheit'] },
      minivan: { title: 'Minivan', desc: 'Für 5-7 Passagiere', features: ['Familienfreundlich', '6+ große Koffer', 'Rollstuhlzugänglich'] },
      airportsCovered: 'Wichtige Flughäfen, die wir bedienen',
    },
    
    languageInterpreter: {
      title: 'Dolmetscher- & Übersetzungsdienste',
      subtitle: 'Überbrücken Sie die Kommunikationslücke während Ihrer medizinischen Reise mit unseren professionellen mehrsprachigen Dolmetschern.',
      mainTitle: 'Klare Kommunikation für bessere Gesundheitsversorgung',
      mainDesc1: 'Wenn es um Ihre Gesundheit geht, zählt jedes Wort. Unsere professionellen medizinischen Dolmetscher stellen sicher, dass bei Ihren Konsultationen und Krankenhausaufenthalten nichts verloren geht.',
      mainDesc2: 'Unsere Dolmetscher sind nicht nur Sprachexperten – sie sind in medizinischer Terminologie geschult und verstehen den Gesundheitskontext.',
      features: {
        languages: { title: 'Über 20 Sprachen verfügbar', desc: 'Arabisch, Russisch, Französisch, Deutsch, Spanisch, Mandarin, Japanisch, Koreanisch, Portugiesisch, Swahili und viele mehr.' },
        medical: { title: 'Experten für medizinische Terminologie', desc: 'Alle Dolmetscher sind in medizinischem Vokabular und Gesundheitsprotokollen geschult.' },
        options: { title: 'Vor-Ort & Remote-Optionen', desc: 'Wählen Sie zwischen physischer Begleitung oder Video-/Telefondolmetschen.' },
        documents: { title: 'Dokumentenübersetzung', desc: 'Übersetzung von medizinischen Berichten, Rezepten, Entlassungsberichten und anderen wichtigen Dokumenten.' },
      },
      servicesInclude: 'Unsere Dolmetscherdienste umfassen',
      servicesList: [
        'Dolmetschen bei ärztlichen Konsultationen',
        'Erklärungen zu Operationen und Verfahren',
        'Medikamenten- und Nachsorgeanweisungen',
        'Hilfe bei der Krankenhausaufnahme',
        'Versicherungs- und Abrechnungssupport',
        'Übersetzung medizinischer Berichte',
        'Rezeptübersetzung',
        'Notfall-Bereitschaftsunterstützung',
        'Dolmetschen bei Videokonsultationen',
        'Apotheken- und Medikamentenberatung',
      ],
      languagesTitle: 'Sprachen, die wir unterstützen',
      languagesList: [
        'Arabisch', 'Russisch', 'Französisch', 'Deutsch', 'Spanisch', 'Mandarin', 
        'Japanisch', 'Koreanisch', 'Portugiesisch', 'Swahili', 'Türkisch', 'Persisch',
        'Bengalisch', 'Urdu', 'Indonesisch', 'Vietnamesisch', 'Thailändisch', 'Italienisch',
        'Niederländisch', 'Polnisch'
      ],
      languagesNote: 'Sehen Sie Ihre Sprache nicht? Kontaktieren Sie uns – wir können Dolmetscher für die meisten Sprachen arrangieren.',
    },
    
    surroundingTours: {
      title: 'Kostenlose Touren in der Umgebung',
      subtitle: 'Machen Sie das Beste aus Ihrer medizinischen Reise mit kostenlosen geführten Touren zu nahegelegenen Attraktionen während Ihrer Genesung.',
      mainTitle: 'Heilung durch Erkundung',
      mainDesc1: 'Genesung beschränkt sich nicht nur auf medizinische Behandlung – es geht auch darum, Ihren Geist und Ihre Seele zu verjüngen. Wir glauben, dass das Erleben der reichen Kultur und natürlichen Schönheit Indiens ein kraftvoller Teil Ihrer Heilungsreise sein kann.',
      mainDesc2: 'Ob Sie an historischen Monumenten, ruhigen Tempeln, lebhaften Märkten oder friedlichen Gärten interessiert sind, unsere lokalen Führer werden Ihnen die Wunder Indiens zeigen.',
      features: {
        guides: { title: 'Erfahrene lokale Führer', desc: 'Sachkundige Führer, die faszinierende Geschichten und Einblicke über jedes Ziel teilen.' },
        itineraries: { title: 'Medizinisch angepasste Routen', desc: 'Touren mit Rastpausen, Barrierefreiheitsoptionen und angemessenem Tempo für genesende Patienten.' },
        cuisine: { title: 'Authentische Küche', desc: 'Probieren Sie lokale Köstlichkeiten mit Berücksichtigung ernährungsbedingter Einschränkungen.' },
        flexible: { title: 'Flexible Zeiteinteilung', desc: 'Touren nach Ihrem Behandlungsplan und ärztlichen Empfehlungen organisiert.' },
      },
      popularDestinations: 'Beliebte Tourenziele',
      mumbaiRegion: 'Region Mumbai',
      delhiRegion: 'Region Delhi',
      includedTitle: 'Was in Ihrer Tour enthalten ist',
      includedList: [
        'Klimatisierter Transport',
        'Professioneller lokaler Führer',
        'Eintrittsgelder zu Monumenten',
        'Flaschenwasser',
        'Leichte Erfrischungen',
        'Rollstuhlzugang bei Bedarf',
        'Fotoassistenz',
        'Medizinischer Notfallkontakt',
      ],
    },
    
    nursingCare: {
      title: 'Pflegeunterstützung',
      subtitle: 'Professionelle Pflege in Ihrer Unterkunft für eine komfortable und sichere Genesungserfahrung.',
      mainTitle: 'Mitfühlende Pflege, wo auch immer Sie sind',
      mainDesc1: 'Die Genesung endet nicht, wenn Sie das Krankenhaus verlassen. Unsere professionelle Pflegeunterstützung bringt Krankenhausqualität direkt in Ihr Hotelzimmer.',
      mainDesc2: 'Ob Sie Hilfe bei der Wundversorgung, IV-Management, Physiotherapieübungen benötigen, oder einfach jemanden, der Ihre Vitalzeichen und Medikamente überwacht, unsere Pflegekräfte bieten aufmerksame, mitfühlende Betreuung.',
      features: {
        registered: { title: 'Registrierte Pflegekräfte', desc: 'Alle unsere Pflegekräfte sind registrierte Fachleute mit Intensiv-, Chirurgie- und häuslicher Pflegeerfahrung.' },
        location: { title: 'Pflege an Ihrem Standort', desc: 'Pflegebesuche in Ihrem Hotel, Serviced Apartment oder jeder Unterkunft Ihrer Wahl.' },
        flexible: { title: 'Flexible Zeiten', desc: 'Wählen Sie zwischen stündlichen Besuchen, Tagespflege oder 24/7-Pflege nach Ihren Bedürfnissen.' },
        emergency: { title: 'Notfallreaktion', desc: 'Geschult im Umgang mit Notfällen mit direkter Kommunikation zu Ihrem Ärzteteam.' },
      },
      servicesTitle: 'Unsere Pflegedienste umfassen',
      servicesList: [
        'Vitalzeichenüberwachung (Blutdruck, Temperatur, Puls, Sauerstoff)',
        'Medikamentenverabreichung und -management',
        'Wundversorgung und Verbandswechsel',
        'IV-Therapie und Injektionen',
        'Katheterpflege und -management',
        'Postoperative Pflege und Überwachung',
        'Diabetesmanagement und Insulinverabreichung',
        'Schmerzmanagement-Unterstützung',
        'Hilfe bei Mobilität und täglichen Aktivitäten',
        'Ernährungs- und Ernährungsüberwachung',
        'Koordination mit Ihren Ärzten',
        'Medizinische Notfall-Erstreaktion',
      ],
      packagesTitle: 'Pflegepaket-Optionen',
      hourlyVisits: { title: 'Stündliche Besuche', desc: 'Geplante Besuche für bestimmte Pflegeaufgaben', features: ['1-4 Stunden Sitzungen', 'Ideal für Wundversorgung', 'Medikamentenhilfe'] },
      dayCare: { title: 'Tagespflege', desc: '8-12 Stunden Pflegeunterstützung', features: ['Tagesüberwachung', 'Mehrere Pflegeaufgaben', 'Aktivitätshilfe'] },
      fullCare: { title: '24/7 Pflege', desc: 'Rund-um-die-Uhr-Pflege', features: ['Kontinuierliche Überwachung', 'Nachtpflege inklusive', 'Umfassende Unterstützung'] },
    },
    
    physiotherapist: {
      title: 'Physiotherapie-Arrangements',
      subtitle: 'Fachkundige Physiotherapie-Dienste zur Beschleunigung Ihrer Genesung und Wiederherstellung der Mobilität.',
      mainTitle: 'Mobilität wiederherstellen, Kraft aufbauen',
      mainDesc1: 'Physiotherapie ist ein entscheidender Bestandteil der Genesung bei vielen medizinischen Eingriffen, insbesondere orthopädischen Operationen und neurologischen Behandlungen.',
      mainDesc2: 'Ob Sie Sitzungen in Ihrem Zimmer oder Besuche in einem nahegelegenen Physiotherapiezentrum benötigen, wir arrangieren personalisierte Behandlungspläne in Absprache mit Ihrem Chirurgen.',
      features: {
        certified: { title: 'Zertifizierte Spezialisten', desc: 'Lizenzierte Physiotherapeuten mit Expertise in postoperativer Rehabilitation und Sportmedizin.' },
        personalized: { title: 'Personalisierte Programme', desc: 'Behandlungspläne, die auf Ihre spezifische Operation, Ihren Zustand und Ihre Genesungsziele zugeschnitten sind.' },
        equipment: { title: 'Moderne Ausstattung', desc: 'Zugang zu fortschrittlichen Physiotherapiegeräten und -techniken.' },
        flexible: { title: 'Flexible Sitzungen', desc: 'Besuche im Zimmer, Kliniktermine oder hybride Arrangements nach Ihren Wünschen.' },
      },
      specializationsTitle: 'Unsere Physiotherapie-Spezialisierungen',
      specializationsList: [
        'Rehabilitation nach Knieersatz',
        'Hüftersatz-Genesung',
        'Wirbelsäulen-OP-Rehabilitation',
        'Schulter- und Rotatorenmanschetten-Therapie',
        'Kardiale Rehabilitation',
        'Neurologische Physiotherapie',
        'Sportverletzungs-Genesung',
        'Schlaganfall-Rehabilitation',
        'Präoperative Stärkung',
        'Gleichgewicht und Sturzprävention',
        'Schmerzmanagement-Therapie',
        'Bewegungsumfangsübungen',
      ],
      journeyTitle: 'Ihre Physiotherapie-Reise',
      journeySteps: [
        { title: 'Erstbewertung', desc: 'Umfassende Bewertung Ihres Zustands, Ihrer Mobilität und Ziele in Absprache mit Ihrem Ärzteteam.' },
        { title: 'Individueller Plan', desc: 'Entwicklung eines personalisierten Behandlungsplans mit spezifischen Übungen und Meilensteinen.' },
        { title: 'Regelmäßige Sitzungen', desc: 'Geführte Physiotherapie-Sitzungen in Ihrer Unterkunft oder nahegelegenen Zentrum.' },
        { title: 'Fortschrittsverfolgung', desc: 'Regelmäßige Bewertung der Verbesserung mit Anpassungen Ihres Behandlungsplans.' },
        { title: 'Heimübungsprogramm', desc: 'Vor Ihrer Abreise erhalten Sie einen umfassenden Übungsleitfaden für die weitere Genesung zu Hause.' },
      ],
    },
    
    travelAccommodation: {
      title: 'Reise- & Unterkunftsarrangements',
      subtitle: 'Komplette Reiseplanung und komfortable Aufenthalte in der Nähe Ihres Krankenhauses – alles für Sie organisiert.',
      mainTitle: 'Ihr Komfort ist unsere Priorität',
      mainDesc1: 'Die Planung einer medizinischen Reise umfasst mehr als nur die Wahl eines Krankenhauses. Von Flugbuchungen bis zur perfekten Unterkunft kümmern wir uns um Ihre gesamte Reiselogistik.',
      mainDesc2: 'Ob Sie ein preiswertes Gästehaus, ein komfortables Hotel oder ein voll ausgestattetes Apartment für längere Aufenthalte bevorzugen, wir haben Partnerschaften mit Unterkünften, die die Bedürfnisse medizinischer Reisender verstehen.',
      features: {
        flights: { title: 'Flugassistenz', desc: 'Hilfe bei der Suche nach den besten Flügen, Visa-Dokumentation und besonderen Assistenzanfragen.' },
        hotels: { title: 'Ausgewählte Unterkünfte', desc: 'Handverlesene Hotels und Apartments in der Nähe großer Krankenhäuser.' },
        location: { title: 'Erstklassige Lagen', desc: 'Unterkünfte in der Nähe von Krankenhäusern, Apotheken und wichtigen Diensten.' },
        quality: { title: 'Qualität gesichert', desc: 'Alle Unterkünfte auf Sauberkeit, Sicherheit und Eignung für medizinische Reisende geprüft.' },
      },
      accommodationTypes: 'Unterkunftsoptionen',
      guesthouse: { title: 'Gästehäuser', desc: 'Erschwinglich, sauber und komfortabel', features: ['Grundlegende Annehmlichkeiten', 'Nähe zu Krankenhäusern', 'Hausmannskost', 'Familienbetrieb'] },
      hotels: { title: 'Hotels (3-5 Sterne)', desc: 'Premium-Komfort und Service', features: ['Zimmerservice 24/7', 'Concierge-Assistenz', 'Restaurant und Café', 'Täglicher Zimmerservice'] },
      apartments: { title: 'Serviced Apartments', desc: 'Ein Zuhause fern der Heimat', features: ['Voll ausgestattete Küche', 'Wohnbereich', 'Langzeit-Rabatte', 'Familienfreundlich'] },
      arrangementsTitle: 'Was wir für Sie organisieren',
      arrangementsList: [
        'Flugbuchungsassistenz',
        'Medizinvisum-Beratung',
        'Unterkunftsauswahl und -buchung',
        'Flughafentransfer-Koordination',
        'Lokale SIM-Karten-Organisation',
        'Währungsumtausch-Beratung',
        'Lokale Gebietsführung',
        'Notfallkontakt-Einrichtung',
        'Verlängerungsarrangements',
        'Begleitperson-Unterkunft',
        'Kommunikation dietetischer Anforderungen',
        'Krankenhaus-Nähe-Kartierung',
      ],
      citiesTitle: 'Wichtige medizinische Zielstädte',
    },
    
    videoConsultations: {
      title: 'Videokonsultationen',
      subtitle: 'Verbinden Sie sich mit Indiens Top-Spezialisten von überall auf der Welt durch sichere Videoanrufe.',
      mainTitle: 'Expertenmeinung, wo auch immer Sie sind',
      mainDesc1: 'Nicht sicher, ob Sie für eine Behandlung nach Indien reisen müssen? Beginnen Sie Ihre Reise mit einer Videokonsultation. Unsere sichere Telemedizin-Plattform verbindet Sie mit Indiens führenden Spezialisten.',
      mainDesc2: 'Videokonsultationen sind perfekt für Erstbewertungen, Behandlungsplanung, Zweitmeinungen und Nachbehandlungs-Follow-ups.',
      features: {
        global: { title: 'Globale Erreichbarkeit', desc: 'Verbinden Sie sich aus jedem Land, jeder Zeitzone. Wir planen Termine, die für Sie passen.' },
        secure: { title: 'HIPAA-konform', desc: 'Ende-zu-Ende verschlüsselte Videoanrufe, die Ihre medizinischen Informationen privat halten.' },
        flexible: { title: 'Flexible Zeiten', desc: 'Frühe Morgen- oder späte Abendtermine für verschiedene Zeitzonen verfügbar.' },
        easy: { title: 'Einfach zu bedienen', desc: 'Einfache Plattform, die auf Telefon, Tablet oder Computer funktioniert. Keine spezielle Software erforderlich.' },
      },
      howItWorks: 'Wie die Videokonsultation funktioniert',
      steps: [
        { title: 'Termin buchen', desc: 'Senden Sie Ihre Anfrage mit Ihren medizinischen Berichten. Unser Team wird Sie mit dem richtigen Spezialisten verbinden.' },
        { title: 'Dokumentenprüfung', desc: 'Der Spezialist prüft Ihre Berichte vor dem Anruf, um Ihre Konsultationszeit optimal zu nutzen.' },
        { title: 'Videokonsultation', desc: 'Nehmen Sie am sicheren Videoanruf zur geplanten Zeit teil. Besprechen Sie Ihren Zustand, stellen Sie Fragen und erhalten Sie Expertenrat.' },
        { title: 'Schriftliche Zusammenfassung', desc: 'Erhalten Sie eine detaillierte Konsultationszusammenfassung mit Diagnose, Empfehlungen und nächsten Schritten.' },
        { title: 'Nachbetreuung', desc: 'Unser Team bleibt verfügbar, um Ihnen zu helfen, die Empfehlungen zu verstehen und Ihre Behandlung zu planen.' },
      ],
      consultationTypes: 'Arten von Videokonsultationen',
      typesList: [
        'Erste medizinische Bewertung',
        'Zweitmeinungs-Konsultation',
        'Behandlungsplanungsbesprechung',
        'Präoperative Konsultation',
        'Nachbehandlungs-Follow-up',
        'Facharztüberweisung-Überprüfung',
        'Medizinische Berichtsinterpretation',
        'Behandlungskostenschätzung',
        'Chirurgie-Machbarkeitsbewertung',
        'Chronisches Erkrankungsmanagement',
      ],
      specialtiesTitle: 'Für Videokonsultation verfügbare Fachgebiete',
    },
  },
  
  // Treatments Page
  treatments: {
    heroTitle: 'Medizinische Behandlungen',
    heroTitleHighlight: 'auf Weltklasseniveau',
    heroSubtitle: 'Indien bietet fortschrittliche medizinische Behandlungen zu einem Bruchteil der Kosten. Entdecken Sie unser umfassendes Angebot an Fachgebieten und Verfahren.',
    jciAccredited: 'JCI-akkreditierte Krankenhäuser',
    costSavings: '60-80% Kostenersparnis',
    expertSurgeons: 'Erfahrene Chirurgen',
    filters: 'Filter',
    showing: 'Anzeige',
    treatmentsCount: 'Behandlungen',
    commonProcedures: 'Häufige Verfahren',
    learnMore: 'Mehr Erfahren',
    savingsCompared: 'Ersparnis im Vergleich zu USA',
  },
  
  // Doctors Page
  doctors: {
    heroTitle: 'Verbinden Sie sich mit Indiens',
    heroTitleHighlight: 'Top-Ärzten',
    heroSubtitle: 'Hochqualifizierte Spezialisten mit internationaler Ausbildung und jahrelanger Erfahrung in ihren Fachgebieten.',
    filterDoctors: 'Ärzte Filtern',
    hideFilters: 'Filter Ausblenden',
    showFilters: 'Filter Anzeigen',
    city: 'Stadt',
    allCities: 'Alle Städte',
    state: 'Bundesland',
    allStates: 'Alle Bundesländer',
    specialization: 'Spezialisierung',
    allSpecializations: 'Alle Spezialisierungen',
    experience: 'Erfahrung',
    anyExperience: 'Jede Erfahrung',
    yearsPlus: 'Jahre+',
    showing: 'Anzeige',
    doctorsCount: 'Ärzte',
    yearsExperience: 'Jahre Erfahrung',
    viewProfile: 'Profil Ansehen',
    requestAppointment: 'Termin Anfragen',
    noResults: 'Keine Ärzte gefunden, die Ihren Kriterien entsprechen',
    tryAdjusting: 'Versuchen Sie, Ihre Filter anzupassen, um mehr Ergebnisse zu sehen',
    clearFilters: 'Filter Löschen',
  },
  
  // Hospitals Page
  hospitals: {
    heroTitle: 'Indiens Führende',
    heroTitleHighlight: 'Krankenhäuser',
    heroSubtitle: 'JCI-akkreditierte Krankenhäuser mit erstklassiger Infrastruktur, modernster Technologie und außergewöhnlicher Patientenversorgung in 9 Bundesstaaten.',
    hospitalsCount: 'Krankenhäuser',
    jciAccredited: 'JCI-Akkreditiert',
    expertTeams: 'Erfahrene Medizinische Teams',
    filters: 'Filter',
    showing: 'Anzeige',
    hospitalsCountLabel: 'Krankenhäuser',
    bedCapacity: 'Bettenkapazität',
    viewHospital: 'Krankenhaus Ansehen',
    specialties: 'Fachgebiete',
    accreditations: 'Akkreditierungen',
  },
  
  // Wellness Page
  wellness: {
    heroTitle: 'Ganzheitliches Wohlbefinden und',
    heroTitleHighlight: 'Erholung',
    heroSubtitle: 'Kombinieren Sie medizinische Behandlung auf Weltklasseniveau mit Indiens uralten Wellness-Traditionen für vollständige Heilung von Körper, Geist und Seele.',
    ayurveda: 'Ayurveda',
    yoga: 'Yoga und Meditation',
    naturopathy: 'Naturheilkunde',
    spa: 'Spa und Verjüngung',
    whyChoose: 'Warum Indien für Wellness Wählen',
    healingTraditions: 'Indien hat eine 5.000-jährige Tradition der ganzheitlichen Heilung durch Ayurveda, Yoga und Naturheilkunde.',
    integratedCare: 'Unsere Wellness-Programme sind darauf ausgelegt, Ihre medizinische Behandlung zu ergänzen und die Genesung zu beschleunigen.',
  },
  
  // Medical Visa Page
  medicalVisa: {
    heroTitle: 'Unterstützung bei',
    heroTitleHighlight: 'Medizinischem Visum',
    heroSubtitle: 'Wir begleiten Sie durch den gesamten Prozess des medizinischen Visums und machen Ihre Gesundheitsreise nach Indien reibungslos und problemlos.',
    whatIs: 'Was ist ein Medizinisches Visum?',
    whatIsDesc: 'Ein medizinisches Visum (M-Visum) wird an ausländische Staatsangehörige ausgestellt, die eine medizinische Behandlung in Indien suchen. Es erlaubt mehrfache Einreisen und ist bis zu einem Jahr gültig.',
    eligibility: 'Berechtigung',
    eligibilityDesc: 'Patienten, die eine Behandlung in anerkannten indischen Krankenhäusern suchen',
    validity: 'Gültigkeit',
    validityDesc: 'Bis zu 1 Jahr oder 3-mal die Behandlungsdauer',
    entries: 'Einreisen',
    entriesDesc: 'Dreifache Einreise, verlängerbar',
    attendants: 'Begleiter',
    attendantsDesc: 'Bis zu 2 medizinische Begleitvisa (MX-Visum)',
    documentsRequired: 'Erforderliche Dokumente',
    howWeHelp: 'Wie Wir Helfen',
  },
};

export default de;
